import React from 'react';
import styles from './index.module.scss';
import { usePageView, useTimeOnPage } from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import RoomScheduleTable from 'component/RoomScheduleTable';

// 容器组件
const Room: React.FC = () => {
  // 埋点
  usePageView(FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_APPOINTMENT);
  useTimeOnPage(FRIDAYAGENT_EVENTS.WEB_TEAMS_TIMEONPAGE_APPOINTMENT);

  return (
    <div className={styles.wrapper}>
      <RoomScheduleTable />
    </div>
  );
};

export default Room;
